import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import BackToTop from '@elem/compCommon/BackToTop';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import K from './components/K';
import L from './components/L'; // 暂未获得授权，临时取消上线
import M from './components/M';
import N from './components/N';
import JoinUs from './components/JoinUs';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('powerbackup');

    const obj: SideMenuProps = {
        items: [
            { text: t('secD_btn1'), link: '#power-backup-E' },
            { text: t('secD_btn2'), link: '#power-backup-F' },
            { text: t('secD_btn3'), link: '#power-backup-G' },
            { text: t('secD_btn4'), link: '#power-backup-H' },
        ],
    };

    const handleAddCart = (card: ShopifyCartItemType) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card.title,
            list_name: 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: shoppingCarts.length + 1,
            button_name: t('common_card_buy'),
        });
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            setShoppingCarts([
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            setShoppingCarts([obj, ...shoppingCarts]);
        }
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D tags={obj.items} />
            <E callBuy={handleAddCart} />
            {['us', 'ca'].includes(locale) && <ProductInlineBanner />}
            <F callBuy={handleAddCart} />
            <G callBuy={handleAddCart} />
            <H callBuy={handleAddCart} />
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.HomeBackup}
                entry_position={['us', 'ca']?.includes(locale) ? 9 : 8}
            />
            <J />
            {['au'].includes(locale) && <JoinUs />}
            {!['kr'].includes(locale) && <K />}
            <L />
            {!['kr'].includes(locale) && <M />}
            <N />
            <h2 className="annotation">{t('secO')}</h2>
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.body)}
        </>
    );
}
